import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconAccountBalanceWallet.tsx
const OutlinedFilledAccountBalanceWallet = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-38.05 0-66.03-27.47Q95-149.95 95-189v-582q0-38.46 27.97-66.73Q150.95-866 189-866h582q39.46 0 67.23 28.27Q866-809.46 866-771v54H540q-54 0-90.5 36.56Q413-643.89 413-592v226q0 53 36.5 88.5T540-242h326v53q0 39-27.77 66.5T771-95H189Zm351-198q-33 0-54.5-20.57-21.5-20.58-21.5-52.68V-592q0-32 21.5-53t54.5-21h291q33 0 54.5 21t21.5 53v225.75q0 32.1-21.5 52.68Q864-293 831-293H540Zm112-123q25 0 44.5-19.5T716-481q0-25-19.5-44T652-544q-25 0-44.5 19T588-481q0 26 19.5 45.5T652-416Z" })
});
const OutlinedAccountBalanceWallet = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-242v53-582 529Zm0 147q-39.8 0-66.9-27.1Q95-149.2 95-189v-582q0-40.21 27.1-67.61Q149.2-866 189-866h582q40.21 0 67.61 27.39Q866-811.21 866-771v125h-95v-125H189v582h582v-124h95v124q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm351-198q-31.35 0-53.67-21.02Q464-335.03 464-366.25V-592q0-29.94 22.33-51.97Q508.65-666 540-666h292.95q30.58 0 52.81 22.03Q908-621.94 908-592v226.25q0 30.01-22.24 51.38Q863.53-293 832.95-293H540Zm308-60v-253H524v253h324Zm-195.76-63q26.76 0 45.26-18.96Q716-453.92 716-481q0-26.25-19-44.63Q678-544 652-544t-45 18.37q-19 18.38-19 44.63 0 27.08 18.74 46.04Q625.47-416 652.24-416Z" })
});
const RoundedFilledAccountBalanceWallet = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-38.05 0-66.03-27.47Q95-149.95 95-189v-582q0-38.46 27.97-66.73Q150.95-866 189-866h582q39.46 0 67.23 28.27Q866-809.46 866-771v54H540q-54 0-90.5 36.56Q413-643.89 413-592v226q0 53 36.5 88.5T540-242h326v53q0 39-27.77 66.5T771-95H189Zm351-198q-33 0-54.5-20.57-21.5-20.58-21.5-52.68V-592q0-32 21.5-53t54.5-21h291q33 0 54.5 21t21.5 53v225.75q0 32.1-21.5 52.68Q864-293 831-293H540Zm112-123q25 0 44.5-19.5T716-481q0-25-19.5-44T652-544q-25 0-44.5 19T588-481q0 26 19.5 45.5T652-416Z" })
});
const RoundedAccountBalanceWallet = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-242v53-582 529Zm0 147q-39.8 0-66.9-27.1Q95-149.2 95-189v-582q0-40.21 27.1-67.61Q149.2-866 189-866h582q40.21 0 67.61 27.39Q866-811.21 866-771v125h-95v-125H189v582h582v-124h95v124q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm351-198q-31.35 0-53.67-21.02Q464-335.03 464-366.25V-592q0-29.94 22.33-51.97Q508.65-666 540-666h292.95q30.58 0 52.81 22.03Q908-621.94 908-592v226.25q0 30.01-22.24 51.38Q863.53-293 832.95-293H540Zm308-60v-253H524v253h324Zm-195.76-63q26.76 0 45.26-18.96Q716-453.92 716-481q0-26.25-19-44.63Q678-544 652-544t-45 18.37q-19 18.38-19 44.63 0 27.08 18.74 46.04Q625.47-416 652.24-416Z" })
});
const SharpFilledAccountBalanceWallet = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-95v-771h771v149H413v475h453v147H95Zm369-198v-373h443v373H464Zm188-123q25 0 44.5-19.5t19.5-45q0-25.5-19.5-44.5T652-544q-25 0-44.5 19T588-480.5q0 25.5 19.5 45T652-416Z" })
});
const SharpAccountBalanceWallet = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-242v53-582 529Zm677-404h-95v-125H189v582h582v-124h95v218H95v-771h771v220ZM464-293v-373h444v373H464Zm188.24-123q26.76 0 45.26-18.96Q716-453.92 716-481q0-26.25-19-44.63Q678-544 652-544t-45 18.37q-19 18.38-19 44.63 0 27.08 18.74 46.04Q625.47-416 652.24-416ZM848-353v-253H524v253h324Z" })
});
const componentMap = {
	outlined: OutlinedAccountBalanceWallet,
	"outlined-fill": OutlinedFilledAccountBalanceWallet,
	rounded: RoundedAccountBalanceWallet,
	"rounded-fill": RoundedFilledAccountBalanceWallet,
	sharp: SharpAccountBalanceWallet,
	"sharp-fill": SharpFilledAccountBalanceWallet
};
const IconAccountBalanceWallet = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconAccountBalanceWallet };